<template>
  <form
    method="POST"
    :action="route"
    style="padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 3rem !important;
    padding-bottom: 1.5rem !important;overflow-x:auto;"
    id="scannerCredentialFormContainer"
  >
    <input type="hidden" name="_token" :value="token" />
    <div class="wrapper">
      <table id="dbp-table">
        <thead>
          <tr>
            <th scope="col">Plateforme</th>
            <th scope="col">Contrat</th>
            <th scope="col">Identifiant</th>
            <th scope="col">Mot de passe</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(investment, index) in invs" :key="index">
            <input type="hidden" :name="'form[' + index + '][id]'" :value="investment.id" />
            <td>
              <select class="mf_select_black" v-model="investment.intermediary" :disabled="investment.id != null" @change="onIntermediaryChange(investment)">
                <option value="" disabled>Plateforme</option>
                <option v-for="intermediary in interms" :key="intermediary.id" :value="intermediary">{{ intermediary.name }}</option>
              </select>
              <input type="hidden" class="mf_input_bl" :name="'form[' + index + '][intermediary_id]'" :value="investment.intermediary.id" />
            </td>
            <td v-if="investment.intermediary.multi_broker == 1">
              <select class="mf_select_black" v-model="investment.platform" :disabled="investment.id != null">
                <option value="" disabled>Contrat</option>
                <option v-for="platform in investment.intermediary.platform" :key="platform.id" :value="platform">{{ platform.name }}</option>
              </select>
              <input type="hidden" :name="'form[' + index + '][platform_id]'" :value="investment.intermediary.platform[0].id" />
            </td>
            <td v-else-if="investment.intermediary.has_branch == 1">
              <select class="mf_select_black" v-model="investment.branch" :disabled="investment.id != null">
                <option value="" disabled>Branch</option>
                <option v-for="branch in investment.intermediary.branchs" :key="branch.id" :value="branch">
                  {{ branch.name }}
                </option>
              </select>
              <input type="hidden" :name="'form[' + index + '][branch_id]'" :value="investment.branch.id" />
            </td>
            <td v-else></td>
            <td>
              <input type="text" class="mf_input_bl" @change="checkValid()" placeholder="Votre identifiant" v-model="investment.login" :name="'form[' + index + '][username]'" />
            </td>
            <td>
              <input type="password" class="mf_input_bl" @change="checkValid()" placeholder="Votre mot de passe" v-model="investment.password" :name="'form[' + index + '][password]'" />
            </td>
            <td style="display:flex">
              <button
                type="button"
                v-on:click="removeRaw(investment)"
                style="background: transparent;
                border: none;
                color: white;
                font-size: 20px;
                font-weight: bold;
                width"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <button type="button" class=" scannerCredentialForm_btn_add" v-on:click="addRaw">
                + Ajouter un compte
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row class="mt-5">
      <button type="submit" class="mf_btn_purple scannerCredentialForm_btn_analyser" :disabled="!valid">
        Analyser mes positions
      </button>
    </b-row>
  </form>
</template>

<script>
export default {
  props: ["intermediaries", "platforms", "branchs", "investments", "token", "route"],

  data() {
    return {
      form: [],
      invs: [],
      interms: [],
      plats: [],
      bras: [],
      valid: false,
    };
  },

  mounted() {
    this.intermediaries.forEach((intermediary) => {
      this.interms.push(intermediary);
    });
    this.platforms.forEach((platform) => {
      this.plats.push(platform);
    });
    this.branchs.forEach((branch) => {
      this.bras.push(branch);
    });

    this.investments.forEach((investment) => {
      investment.login = "";
      investment.password = "";
      this.invs.push(investment);
    });

    this.invs.forEach((investment) => {
      investment.intermediary = this.interms.find((intermediary) => investment.intermediary.id === intermediary.id);
    });

    if (this.invs.length == 0) {
      this.addRaw();
    }
  },
  methods: {
    onIntermediaryChange(investment) {
      investment.intermediary.platform = this.plats.filter((platform) => platform.intermediary_id === investment.intermediary.id);
      investment.platform = investment.intermediary.platform[0];

      if (investment.intermediary.has_branch == 1) {
        investment.branch = investment.intermediary.branchs[0];
      }
    },

    addRaw() {
      var investment = {
        intermediary: this.interms[0],
        platform: null,
        branch: this.interms[0].branchs[0],
        login: "",
        password: "",
      };
      this.invs.push(investment);
      this.onIntermediaryChange(investment);
      this.checkValid();
    },

    removeRaw(investment) {
      this.invs.splice(this.invs.indexOf(investment), 1);
      this.checkValid();
    },

    checkValid() {
      this.valid = false;
      if (this.invs.length > 0) {
        this.valid = true;
      }
      this.invs.forEach((investment) => {
        if (investment.login == "" || investment.password == "") {
          this.valid = false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
.wrapper {
  overflow: auto;
  border-radius: 20px;
  background-color: #121212;
}
#dbp-table {
  $thRadius: 20px;
  width: 100%;

  .tbHeader {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .tbHeader_label {
      margin-right: 15px;
    }
  }

  .table thead th {
    vertical-align: bottom;
    border: none;
  }

  thead {
    background: transparent;
  }

  th {
    background-color: #121212;
    border: none;
    color: #f5f5f5;
    text-align: center;
    padding: 10px;
  }

  th:first-child {
    border-top-left-radius: $thRadius;
  }

  th:last-child {
    border-top-right-radius: $thRadius;
  }

  tr {
    border: none;
    text-align: center;
    font: normal normal bold $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: #cacaca;
    opacity: 1;
  }

  td {
    border: none;
    padding: 10px;
  }

  li > span {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: black;
    background-color: transparent !important;
    border: none !important;
    cursor: pointer;
    font-size: 20px !important;
    font-weight: bold !important;
  }
}
#scannerCredentialFormContainer {
  #credentialForm_table {
    width: 100%;
    tbody:before {
      content: "@";
      display: block;
      line-height: 10px;
      border-radius: 20px;
      text-indent: -99999px;
    }
    thead {
      tr {
        border: none;
        background: #121212 0% 0% no-repeat padding-box;
        border-radius: 20px;
        opacity: 1;
        th {
          text-align: center;
          font: normal normal bold $mf_ft_size_text Segoe UI;
          letter-spacing: 0px;
          color: #ffffff;
          opacity: 1;
          padding: 15px;
          &:first-child {
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          &:last-child {
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          }
        }
      }
    }
    tbody {
      background: #121212 0% 0% no-repeat padding-box;
    }
  }
  .scannerCredentialForm_btn_add {
    background: #333436 0% 0% no-repeat padding-box;
    border-radius: 33px;
    opacity: 1;
    color: $mf_ft_color_white;
    border: none;
    width: 40%;
    margin-top: 10px;
    padding: 5px;
    text-align: center;
    font: normal normal bold $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: #cacaca;
    opacity: 1;

    span {
      font-size: 20px;
      color: white;
    }
  }

  .scannerCredentialForm_btn_analyser {
    font: normal normal bold $mf_ft_size_text Segoe UI;
    width: 50%;
    margin: auto;
  }
}
</style>
